import React from "react";
import { Box, HStack, VStack, Text, Icon, Button, ButtonGroup } from "@chakra-ui/react";
import { FaTasks } from "react-icons/fa";
import { AddIcon } from "@chakra-ui/icons";
import { BsArrowUp } from "react-icons/bs";
import Tasks from "../Tasks";

export default function TasksSection({
  ticket,
  resellerID,
  MotionBox,
  colorScheme,
  createBulkTaskModalState,
  createTaskModalState,
  handleScrollToTicket,
  componentsLoading,
  setComponentLoading,
  tasksRef,
  ticketRendered,
  revalidator,
  ticketRef,
}) {
  return (
    <MotionBox
      bg={colorScheme.cardBg}
      borderRadius="2xl"
      shadow="xl"
      border="1px solid"
      borderColor={colorScheme.borderColor}
      overflow="hidden"
      _hover={{ shadow: "2xl", transform: "translateY(-1px)" }}
      sx={{ transition: "all 0.3s ease" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.5 }}
    >
      <Box bgGradient={colorScheme.headerBg} px={{ base: 4, md: 6, lg: 8 }} py={{ base: 4, md: 5 }} position="relative">
        <Box
          position="absolute"
          top={0}
          right={0}
          width={{ base: "60px", md: "100px" }}
          height={{ base: "60px", md: "100px" }}
          bgGradient="radial(circle, whiteAlpha.100 0%, transparent 70%)"
          pointerEvents="none"
        />
        <HStack spacing={{ base: 3, md: 4 }} justify="space-between" width="100%">
          <HStack spacing={4}>
            <Box bg="whiteAlpha.200" p={3} borderRadius="lg" backdropFilter="blur(10px)">
              <Icon as={FaTasks} color="white" boxSize={6} />
            </Box>
            <VStack align="start" spacing={1}>
              <Text color="white" fontSize="xl" fontWeight="bold">
                Görevler
              </Text>
              <Text color="whiteAlpha.800" fontSize="sm">
                Ticket ile ilgili görevler
              </Text>
            </VStack>
          </HStack>

          <ButtonGroup size={'sm'}>
            <Button leftIcon={<AddIcon />} onClick={createBulkTaskModalState.onOpen} data-tour-id="bulk-task">Çoklu Görev Ekle</Button>
            <Button leftIcon={<AddIcon />} onClick={createTaskModalState.onOpen} data-tour-id="subtask">Alt Görev Ekle</Button>
            <Button rightIcon={<BsArrowUp />} onClick={handleScrollToTicket} data-tour-id="scroll-to-ticket">İş Emrine Çık</Button>
          </ButtonGroup>
        </HStack>
      </Box>

      <Box p={8}>
        {componentsLoading.tasks ? (
          <VStack spacing={4} align="stretch">
            <Box height="60px" borderRadius="md" bg="blackAlpha.100" />
            <Box height="60px" borderRadius="md" bg="blackAlpha.100" />
            <Box height="60px" borderRadius="md" bg="blackAlpha.100" />
          </VStack>
        ) : (
          <Tasks
            tasks={ticket.tasks}
            ticketURL={ticket.url}
            resellerID={resellerID}
            ticketRevalidator={revalidator}
            ticketRendered={ticketRendered}
            ticketRef={ticketRef}
            ref={tasksRef}
            onLoadingChange={(loading) => setComponentLoading('tasks', loading)}
          />
        )}
      </Box>
    </MotionBox>
  );
}